import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Paper, Typography, Link } from '@mui/material';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import LoginForm from '../components/LoginForm';
import { useAuth } from '../../../shared/context/AuthContext';
import { getDefaultDashboard } from '../../../shared/config/roleConfig';

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, newPasswordRequired, loading, error, login, clearError, user } =
    useAuth();

  const from = location.state?.from?.pathname;

  useEffect(() => {
    if (newPasswordRequired) {
      navigate('/new-password', { replace: true });
    } else if (isAuthenticated) {
      const redirectTo = from || getDefaultDashboard(user?.role);
      navigate(redirectTo, { replace: true });
    }
  }, [isAuthenticated, newPasswordRequired, navigate, from, user]);

  useEffect(() => {
    return () => {
      clearError();
    };
  }, [clearError]);

  const handleLogin = (data) => {
    login(data);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#E8F5E9',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='800' height='800' viewBox='0 0 800 800' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' stroke='%23C8E6C9' stroke-width='1'%3E%3Cellipse cx='400' cy='400' rx='50' ry='50'/%3E%3Cellipse cx='400' cy='400' rx='100' ry='100'/%3E%3Cellipse cx='400' cy='400' rx='150' ry='140'/%3E%3Cellipse cx='400' cy='400' rx='200' ry='185'/%3E%3Cellipse cx='400' cy='400' rx='260' ry='240'/%3E%3Cellipse cx='400' cy='400' rx='320' ry='300'/%3E%3Cellipse cx='400' cy='400' rx='390' ry='360'/%3E%3Cellipse cx='400' cy='400' rx='460' ry='420'/%3E%3Cellipse cx='400' cy='400' rx='540' ry='490'/%3E%3Cellipse cx='400' cy='400' rx='620' ry='560'/%3E%3Cellipse cx='400' cy='400' rx='700' ry='640'/%3E%3C/g%3E%3C/svg%3E")`,
        backgroundSize: '120%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Logo */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 4 }}>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: '10px',
            backgroundColor: '#2E7D32',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <InsertChartIcon sx={{ color: '#fff', fontSize: 28 }} />
        </Box>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: '#212121',
            letterSpacing: '-0.3px',
          }}
        >
          Maintenance AI
        </Typography>
      </Box>

      {/* Login Card */}
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 400,
          borderRadius: '16px',
          p: 4,
          boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: 700, color: '#212121', mb: 0.5 }}
        >
          Login
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: '#399432', mb: 3 }}
        >
          Enter your details below to login
        </Typography>

        <LoginForm onSubmit={handleLogin} loading={loading} error={error} />

        <Box sx={{ textAlign: 'left', mt: 2 }}>
          <Link
            href="#"
            underline="none"
            sx={{
              color: '#424242',
              fontSize: '0.875rem',
              fontWeight: 500,
              '&:hover': { color: '#2E7D32' },
            }}
          >
            Forgot your password?
          </Link>
        </Box>
      </Paper>
    </Box>
  );
};

export default LoginPage;
